import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';
import { Settings } from '../../lib/app.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../service/common/common.service';
import { Observable, Subscription } from 'rxjs';
import { MenuItem, MessageService } from 'primeng/api';
import { AdministrationService } from '../../service';
import moment from 'moment';
import { AppMainComponent } from '../main-panel/app.main.component';
import { SidebarFilterComponent } from '../sidebar-filter/sidebar-filter.component';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-crud-grid',
  templateUrl: './crud-grid.component.html',
  styleUrls: ['./crud-grid.component.scss']
})
export class CrudGridComponent {
masterDataGridSchema = [
  { field: 'source_system_name', header: 'Source System' },
  { field: 'source_system_id', header: 'Source System ID' },
];
public showFilter: boolean = false;
@Input() buttonConfig: any;
@Input() total_records=Settings.GridConfiguration.totalRecords;
@Input() page_size=Settings.GridConfiguration.pageSize;
@Input() order_type=Settings.GridConfiguration.orderType;
@Input() default_order_by=Settings.GridConfiguration.orderBy;
@Input() date_range='';
@Input() loading=false;
@Input() grid_schema=[];
@Input() businessUnitList=[];
@Input() fileTypeList=[];
@Input() countryList=[];
@Input() data=[];
@Input() doc_type_list=[];
@Input() module_id:any;
@Input() callback: (val:boolean) => void;
@Input() viewPdf:(data:{})=>void;
@Input() viewConfig:(data:{})=>void;
@Output() filterModelChange = new EventEmitter<any>();
@Input() edit: (body:{},id:string) => void;
@Input() copy: (body:{}) => void;
@Input() delete: (id:string) => void;
@Input() controllerClick: (document:any) => void;
@Input() sortGrid:(event:Partial<Event>)=>void;
@Input() paginateEvent:(event:Partial<Event>)=>void;
@Input() export:()=>void;
@Input() filterModel=null;
@Input() page_number=1;
// @Input() router:Partial<Router>;
@Output() resetFilters: EventEmitter<void> = new EventEmitter<void>();
@Output() downloadFileData: EventEmitter<any> = new EventEmitter<any>();
@Output() superUserEvent: EventEmitter<any> = new EventEmitter<any>();
@Output() payloadData: EventEmitter<any> = new EventEmitter<any>();
@Output() assignUserData: EventEmitter<any> = new EventEmitter<any>();
@Output() cancelTicketData: EventEmitter<any> = new EventEmitter<any>();
@Output() approvalLog = new EventEmitter<{ event: Event, document: any }>();
@Output() viewTicketLog: EventEmitter<void> = new EventEmitter<void>();
@Output() ticketLogClicked = new EventEmitter<{ event: Event, document: any }>();
@Output() privilegeData: EventEmitter<any>=new EventEmitter<any>();
@Output() applicationData: EventEmitter<any>=new EventEmitter<any>();
@Output() superUserData: EventEmitter<void>=new EventEmitter<void>();
@Output() businessAllocationData: EventEmitter<any>=new EventEmitter<any>();
@Output() viewVersion: EventEmitter<any>=new EventEmitter<any>();
@Output() appToken: EventEmitter<any>=new EventEmitter<any>();
@Output() columnSettingsChange: EventEmitter<any[]> = new EventEmitter<any[]>();
@ViewChild(SidebarFilterComponent) sidebarFilterComponent!: SidebarFilterComponent;
@Output() viewD365Logs = new EventEmitter<{ legal_entity: string; accountNumber: string | null }>();
@Output() viewD365TicketLogs = new EventEmitter<{ legal_entity: string; accountNumber: string | null }>();
@Input() onDownloadVendorChangeFile: (document: any) => void;
@Input() onDownloadD365File: (document: any) => void;
@Input() onClickContactsFile: (document: any) => void;
@Input() onClickAddressFile: (document: any) => void;
@Input() onClickBankDetailsFile: (document: any) => void;
@Input() onClickSerticaContactsFile: (document: any) => void;
documentFieldList: any;
isSuperuser:boolean=false;
userDetails$ : Observable<any>;
saveClicked: boolean = false;
@ViewChild('paginator', { static: true }) paginator: Paginator;
refresh_event_click_subscription:Subscription;
page_size_list=Settings.GridConfiguration.pageSizeList;
jumpToPageNo: string;
items: MenuItem[]=[
  {
    icon: 'fas fa-file-download',
    tooltipOptions: {
      tooltipLabel: "Export",
      tooltipPosition: "left"
    },
    command:()=>this.onClickExportExcel()
},
];
  showColumnSettingsModal: boolean;
  user_schema: any[];
  filtered_grid_schema: any[];
  applicationList$:Observable<any>;
  applicationList: any[]=[];
  selectedApplicationId: any;
    http: any;
    viewableUrl: string;
  vendorMapData: any[]=[];
  userDetails: any;

constructor(private messageService:MessageService,public router:Router,private store: Store<any>,public appMain: AppMainComponent,public commonService:CommonService,public adminService:AdministrationService){
  this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
}

ngOnInit(){
      this.messageService.clear();
  this.appMain.configActive = false;
      this.userDetails$.subscribe(data => {
        this.userDetails = data;
      });
  this.getRefreshEvent();
    this.getGridSchemaFilter();
}

onClickShowColumnSettingsModal(){
  this.showColumnSettingsModal=true;
}
onClickResetColumnSettings(){
  this.user_schema=JSON.parse(JSON.stringify(this.filtered_grid_schema));
}

onClickSaveColumnSettings() {
  this.saveClicked = true;
  this.columnSettingsChange.emit(this.user_schema);
  this.showColumnSettingsModal = false;
}

onHideColumnSettings(){
  if (!this.saveClicked) {
    this.onClickResetColumnSettings();
  }
  this.saveClicked = false;
}

getGridSchemaFilter(){
 this.grid_schema.forEach((col) => {
    if (col.filter_type !== 'input' && col.filter_type !== 'calendar') {
      col.filter_options=[]
      if (col.key == 'is_active') {
        col.filter_options = [
          { name: 'Active', value: true },
          { name: 'Inactive', value: false }
        ];
      }
      else if(col.is_library_available){
      this.fetchDropdownOptions(col);
      }
      else{
        if(col.url_id){
          this.fetchDropDownOptionByUrl(col);
         }else{
        col.filter_options=[];
         }
      }
    }
  });
  this.filtered_grid_schema=JSON.parse(JSON.stringify(this.grid_schema));
}

fetchDropDownOptionByUrl(col){
  this.adminService.getUrlDropdown(col.url_id).subscribe({
    next: (options: any) => {
      col.filter_options = options?.map((option: any) => ({
        name: option.value,
        value: option.id
      }));
    },
    error: (err) => {
      console.error(`Error fetching dropdown options for column ${col.label}:`, err);
    }
  });
}

fetchDropdownOptions(col: any) {
  this.adminService.getDocumentFieldLibrary({"column_id":col.id}).subscribe({
    next: (options: any) => {
      col.filter_options = options?.results.map((option: any) => ({
        name: option.key,
        value: option.value
      }));
    },
    error: (err) => {
      console.error(`Error fetching dropdown options for column ${col.label}:`, err);
    }
  });
}

onClickReset() {
  this.documentFieldList=[];
  if (!this.filterModel) {
    this.filterModel = {};
  }
  if (!this.filterModel.data_elements) {
    this.filterModel.data_elements = {};
  } else {
    this.filterModel.data_elements = {};
  }
  this.resetFilters.emit();
  if(this.sidebarFilterComponent){
  this.sidebarFilterComponent.templateData=null;
  this.sidebarFilterComponent.showUpdate=false;
  }
  this.closeSidebar();
}
getStatusClass(status: any): string {
  if (typeof status !== 'string') return '';
  return status
    ?.toLowerCase()
    ?.trim()
    ?.replace(/\s+/g, '-'); // replace spaces with hyphens
}

onClickDownloadUploadedFile(id){
this.downloadFileData.emit(id)
}
onClickDownloadAttachmentFile(file_content,file_name){
let downloadUrl=CommonService.generateFileUrl(file_content,file_name);
const link = document.createElement('a');
link.href = downloadUrl;
link.target='_blank'
link.download = file_name??'Astro_Attachment'; // Specify the desired file name here
link.click();
window.URL.revokeObjectURL(downloadUrl);
}
onClickDownloadAttachment(id: any, file_name: any) {
    this.commonService.getAnnouncementFile(id).subscribe({
        next: (res: any) => {
            if (res?.file_content) {
              try {
                let byteCharacters = atob(res.file_content);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const downloadUrl = URL.createObjectURL(blob);

                // window.open(downloadUrl, '_blank');

                const link = document.createElement('a');
                const fileName = res.file_name || 'download.pdf';
                link.href = downloadUrl;
                link.download = fileName;
                link.click();

                setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // Clean up
                this.viewableUrl = downloadUrl;
              } catch (err) {
              }
            } else {
            }
          },
      error: () => {
      }
    });
  }

onConfigButtonClick(event) {
  this.appMain.configActive = !this.appMain.configActive;
  this.appMain.configClick = true;
  event.preventDefault();
}
getRefreshEvent(){
  this.refresh_event_click_subscription = this.commonService.getRefreshEvent().subscribe((res) => {
    const event = { page: this.page_number-1 } as Partial<Event>;
      this.paginate(event);
  })
}

onClickAddUpdateModal() {
  if (this.callback) {
      this.callback(true);
  }
}

onDateSelect(data:{event: any, colKey: string}) {
  let event = data.event;
  let colKey = data.colKey;
  if (event) {
    this.filterModel[`${colKey}_start_date`] = event[0] ? moment(event[0]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
    this.filterModel[`${colKey}_end_date`] = event[1] ? moment(event[1]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
  } else {
    this.filterModel[`${colKey}_start_date`] = null;
    this.filterModel[`${colKey}_end_date`] = null;
  }
}
onDateSelectGrid(event: any, colKey: string) {
  if (event) {
    this.filterModel[`${colKey}_start_date`] = event[0] ? moment(event[0]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
    this.filterModel[`${colKey}_end_date`] = event[1] ? moment(event[1]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
  } else {
    this.filterModel[`${colKey}_start_date`] = null;
    this.filterModel[`${colKey}_end_date`] = null;
  }
}

onClickDelete(id:string) {
  if (this.delete) {
      this.delete(id);
  }
}

onClickEdit(data,id){
if(this.edit){
  this.edit(data,id);
}
}

onClickCopy(data){
  if(this.copy){
    this.copy(data);
  }
  }

onClickController(document: any) {
  if (this.controllerClick) {
    this.controllerClick(document);
  }
}

onClickExportExcel(){
  if(this.export){
    this.export();
  }
}
clearFilterModel(){
  this.filterModel={};
}

  populateFilterTemplateData(data){
    this.filterModel=data;
    const findDateKeys = (obj) => {
      return Object?.keys(obj).filter(key => key?.includes('_on') || key?.includes('_date'));
  };
  const dateKeys = findDateKeys(data);
  dateKeys.forEach(dateKey => {
      if (data?.[dateKey]) {
        const dateValue = data[dateKey];
        if (Array.isArray(dateValue) && dateValue.length > 0) {
          let [firstDate, secondDate] = dateValue;
          if (!firstDate && secondDate) {
            firstDate = secondDate;
          }
          if (!secondDate && firstDate) {
            secondDate = firstDate;
          }
          this.filterModel[dateKey] = [new Date(firstDate), new Date(secondDate)];
      } else {
          this.filterModel[dateKey] = null;
      }
      }
  })
  setTimeout(() => {
    dateKeys.forEach(dateKey => {
        if (this.filterModel[dateKey] && Array.isArray(this.filterModel[dateKey])) {
            const formattedDates = this.filterModel[dateKey].map(date => {
                return date instanceof Date ? moment(date).format(Settings.DateFormats.dateFormatOnlyDate) : date;
            });
            this.onDateSelectGrid(formattedDates, dateKey);
        }
    });
    this.filterModelChange.emit(this.filterModel);
}, 1000);
  }

onClickFilter(){
  if(this.module_id==Settings.Module.USERS_ADMIN){
  if (!this.filterModel) {
    this.filterModel = {};
  }
  this.filterModel.document_type_id = this.filterModel?.document_type_name || null;
}
  this.filterModelChange.emit(this.filterModel);
  if(this.data?.length>0){
  this.paginator.changePage(0);
  }else{
    const event = { page: this.page_number-1 } as Partial<Event>;
    this.paginate(event);
  }
  this.closeSidebar();
}

paginate(event){
  if(this.paginateEvent){
    let data={
      ...event,
      orderType:this.order_type,
      orderBy:this.default_order_by
    }
    this.paginateEvent(data);
  }
}

sortColumn(event){
  this.default_order_by = event?.sortField;
  this.order_type = event?.sortOrder;
  if (this.sortGrid) {
    if(this.page_number==1){
      this.sortGrid(event);
    }else{
    this.paginator.changePage(0);
    }
   }
}

jumpToPage(event){
  if(event.target.value){
  if(event.target.value<=this.paginator.paginatorState.pageCount){
  this.paginator.changePage((event.target.value-1));
  this.jumpToPageNo="";
  }
}
}

onClickNavigateToDocumentFieldConfig(data){
  this.router.navigate([`/user/admin/document-field/${data?.application_id}/${data?.id}`])
}

// onClickViewPDF(data){
//   if(this.viewPdf){
//     this.viewPdf(data);
//   }
// }
getScrollHeight(options: any[]): string {
  if (!options) return '200px';
  const rowHeight = 36; 
  const visibleRows = Math.min(options?.length, 6); 
  return `${visibleRows * rowHeight}px`;
}


onClickViewPDF(data) {
   sessionStorage.setItem('vendorLoadComponent', '0');
   if(data?.ticket_type==Settings.TicketType.CREATE || data?.ticket_type==Settings.TicketType['SPECIAL CREATE']){
  if(data?.is_self && (data?.status==Settings.StatusCodeEnum['ONGOING ADJUSTMENTS'])){
   const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/supplier/reopen', data?.id])
    );
    window.open(url, '_blank');
  }
  else if(data?.is_self && data?.status==Settings.StatusCodeEnum.DRAFT) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/supplier/create', data?.id])
    );
    window.open(url, '_blank');
  }
  else{
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/record/view', data?.id])
    );
    window.open(url, '_blank');
  }
}
else if(data?.ticket_type==Settings.TicketType['OTHER-OTHER']){
        if ( data?.is_self && (data?.status == Settings.StatusCodeEnum['ONGOING ADJUSTMENTS'])) {
           const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/other-requests/other-reopen', data?.id])
    );
        window.open(url, '_blank');
        }else{
            const url = this.router.serializeUrl(
    this.router.createUrlTree(['/user/record/view', data?.id])
  );
  window.open(url, '_blank');
}
}
else if(data?.ticket_type==Settings.TicketType['EXTEND TO LOB']){
        if ( data?.is_self && (data?.status == Settings.StatusCodeEnum['ONGOING ADJUSTMENTS'])) {
           const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/other-requests/extend-to-lob-reopen', data?.id])
    );
        window.open(url, '_blank');
        }else{
            const url = this.router.serializeUrl(
    this.router.createUrlTree(['/user/record/view', data?.id])
  );
  window.open(url, '_blank');
}
}
else if(data?.ticket_type==Settings.TicketType['OTHER-BULK BLOCK/UPDATE']){
        if ( data?.is_self && (data?.status == Settings.StatusCodeEnum['ONGOING ADJUSTMENTS'])) {
           const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/other-requests/bulk-block-update-reopen', data?.id])
    );
        window.open(url, '_blank');
        }else{
            const url = this.router.serializeUrl(
    this.router.createUrlTree(['/user/record/view', data?.id])
  );
  window.open(url, '_blank');
}
}
else if(data?.ticket_type==Settings.TicketType['CREATE/UPDATE EMPLOYEE VENDOR ACCOUNT']){
        if ( data?.is_self && (data?.status == Settings.StatusCodeEnum['ONGOING ADJUSTMENTS'])) {
           const url = this.router.serializeUrl(
      this.router.createUrlTree(['/user/other-requests/create-update-employee-vendor-reopen', data?.id])
    );
        window.open(url, '_blank');
        }else{
            const url = this.router.serializeUrl(
    this.router.createUrlTree(['/user/record/view', data?.id])
  );
  window.open(url, '_blank');
}
}
else{
  const url = this.router.serializeUrl(
    this.router.createUrlTree(['/user/record/view', data?.id])
  );
  window.open(url, '_blank');
}
}
    onClickVendorView(vendorId: number) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/user/master-data/supplier-view', vendorId])
        );
        window.open(url, '_blank');
    }

onClickViewVendorMapData(data){
  this.vendorMapData=data?.vendor_master_data || [];
  this.vendorMapData.map((el:any)=>{
    el.source_system_name=el?.source_system?Settings.LobType[el?.source_system]:el?.source_system;
  })
}
onClickViewD365Log(legal_entity: string, accountNumber: string | null): void {
    if (accountNumber) {
      this.viewD365Logs.emit({ accountNumber, legal_entity });
    }
}
onClickViewD365TicketLog(legal_entity: string, accountNumber: string | null): void {
    if (accountNumber) {
      this.viewD365TicketLogs.emit({ accountNumber, legal_entity });
    }
}
onClickViewSourceSystem(data){
if(data?.source_system==Settings.LobType.Sertica){
  this.router.navigate(['user/master-data/sertica-database', data?.source_system_id]);
}
if(data?.source_system==Settings.LobType.LSRetail){
  this.router.navigate(['user/master-data/lsretail-database', data?.source_system_id]);
}
if(data?.source_system==Settings.LobType.Velocity){
  this.router.navigate(['user/master-data/velocity-database', data?.source_system_id]);
}
}
onClickViewVendor(document: any): void {
    let sourceId: string;
    if (document?.address_book_no) {
      // Sertica
      sourceId = document.address_book_no;
    } else if (document?.supplier_visma_id) {
      // Velocity
      sourceId = document.supplier_visma_id.toString();
    } else if (document?.no) {
      // LS Retail
      sourceId = document.no;
    } else {
      // Fallback
      sourceId = document?.source_id;
    }
    if (sourceId) {
      this.router.navigate(['user', 'master-data', 'supplier-list', sourceId]);
    } else {
    }
  }

  isExpired(dateUtc: string): boolean {
    if(!dateUtc){
      return false
    }
  return new Date(dateUtc)?.getTime() < new Date()?.getTime();
}

isNotExpired(dateUtc: string): boolean {
  return new Date(dateUtc)?.getTime() >= new Date()?.getTime();
}

isUnderGpInvestigation(document: any): boolean {
  const onHold =
    document?.is_gp_on_hold === true ||
    document?.vendor_summary?.is_gp_on_hold === true;
  return onHold && !document?.expires_on;
}


onClickViewConfig(data){
  if(this.viewConfig){
    this.viewConfig(data);
  }
}

onClickPayloadIcon(data){
this.payloadData.emit(data);
}
onClickAssignUser(data){
  this.assignUserData.emit(data);
  }
//   onClickCancelUser(data: any) {
//     this.cancelTicketData.emit(data);
//   }
  onTicketLogClick(event: Event, document: any) {
    this.ticketLogClicked.emit({ event, document });
  }
  onClickApprovalLog(event: Event, document: any) {
    this.approvalLog.emit({ event, document });
  }
onChangeSuperUser(event,data){
  let userData={
    ...event,
    ...data
  }
this.superUserEvent.emit(userData);
}
onClickViewPrivileges(data){
  this.privilegeData.emit(data);
}
onDownload(document: any): void {
    if (this.onDownloadVendorChangeFile) {
      this.onDownloadVendorChangeFile(document);
    }
}
onClickContacts(document: any): void {
  if (this.onClickContactsFile) {
    this.onClickContactsFile(document);
  }
}
onClickAddress(document: any): void {
    if (this.onClickAddressFile) {
      this.onClickAddressFile(document);
    }
}
onClickBankDetails(document: any): void {
    if (this.onClickBankDetailsFile) {
      this.onClickBankDetailsFile(document);
    }
}
onClickSerticaContacts(document: any): void {
    if (this.onClickSerticaContactsFile) {
      this.onClickSerticaContactsFile(document);
    }
}
downloadD365File(document: any): void {
    if (this.onDownloadD365File) {
      this.onDownloadD365File(document);
    }
}
onClickViewApplicationPrivileges(data){
  this.applicationData.emit(data);
}
onClickViewSuperUserApplicationPrivileges(){
  this.superUserData.emit();
}
onClickGenerateToken(data){
  this.appToken.emit(data);
}
closeSidebar() {
  this.showFilter = false;
  // this.filterModel.document_type_name=this.filterModel.document_type_id;
}

oClickViewVersions(data){
this.viewVersion.emit(data);
}

ngOnDestroy(){
  this.refresh_event_click_subscription.unsubscribe();
}

getRoleName(document){
let selectedApplicationId = JSON.parse(localStorage.getItem('selectedApplicationId'));
const roleData = document?.role_data?.find(role => role.application_id === selectedApplicationId);
return roleData?.role_name??null;
}

getApplicationName(document){
  const data = this.applicationList?.find(application => application.id === document?.application_id);
  return data?.application_name??null;
  }

onClickApplyOptionsFilter(options){
  options.hide();
  this.onClickFilter();
}

onClickClearOptionsFilter(options,key){
  this.filterModel[key]=null;
  options.hide();
}

hasFilterValues(): boolean {
    if (!this.filterModel) {
      return false;
    }
    return Object.values(this.filterModel).some(value => {
      if (value == null) {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object') {
        return Object.values(value).some(val => val != null && val !== '');
      }
      return value !== '';
    });
}
@HostListener('document:keydown', ['$event'])
handleKeyboardEvent(event: KeyboardEvent) {
    if (event?.key == 'Enter' && !event?.shiftKey) {
        if (this.showFilter) {
                this.onClickFilter();
        }
    }
}

}
